// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fvTA","colBig":"styles_colBig__1sHCI","colSmall":"styles_colSmall__3BFhb","shopifyNameWrapper":"styles_shopifyNameWrapper__MDJe_"};